class ViewSwitch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleViewToggle = this.handleViewToggle.bind(this)

    this.listeners.add(this.els.toggle.element, 'click', this.handleViewToggle)
  }

  async handleViewToggle () {
    const listClass = `clc-ProductGrid`

    const viewportMode = window.BAO.MediaBreakpoints.isMd
      ? 'desktop'
      : 'mobile'

    const currentView =
      viewportMode === 'desktop'
        ? this.dataset.desktopView
        : this.dataset.mobileView

    const newView = currentView === 'Standard' ? 'Large' : 'Standard'

    if (viewportMode === 'desktop') {
      await window.BAO.Cart.updateCartAttributes({
        desktop_view: newView,
      })
    } else {
      await window.BAO.Cart.updateCartAttributes({
        mobile_view: newView,
      })
    }

    this.setAttribute(`data-${viewportMode}-view`, newView)

    this.externalEls.grid.element.classList.remove(
      `${listClass}-${viewportMode}${currentView}`,
    )
    this.externalEls.grid.element.classList.add(
      `${listClass}-${viewportMode}${newView}`,
    )
  }
}

if (!customElements.get('view-switch')) {
  customElements.define('view-switch', ViewSwitch)
}
